import React, { useState, useEffect } from "react";
import { BASE_URL } from "../utils/config";
import Sidebar from "../components/sidebar";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from '@mui/icons-material/Delete';
import Stack from "@mui/material/Stack";
import Loading from "../components/loading";

import { Tabs, Tab } from "@mui/material";


const AutomateScriptRecord = () => {
  const columns = [
    { id: "Action", label: "Action", minWidth: 70 },
    { id: "S.No", label: "S.No", minWidth: 40 },
    { id: "Stock_name", label: "Stock Symbol", minWidth: 110 },
    { id: "name", label: "Stock Name", minWidth: 120 },
    { id: "last_price", label: "Last Price", minWidth: 90 },
    { id: "lot_size", label: "LotSize", minWidth: 80 },
    { id: "last_quantity", label: "Last Quan", minWidth: 100 },
    { id: "buy_quantity", label: "Buy Quan", minWidth: 90 },
    { id: "sell_quantity", label: "Sell Quan", minWidth: 110 },
    { id: "volume", label: "Volume", minWidth: 110 },
    { id: "lower_circuit_limit", label: "LC Limit", minWidth: 110 },
    { id: "upper_circuit_limit", label: "UC Limit", minWidth: 110 },
    { id: "open", label: "Open", minWidth: 110 },
    { id: "high", label: "Close", minWidth: 110 },
    { id: "low", label: "Low", minWidth: 110 },
    { id: "close", label: "Close", minWidth: 110 },
  ];
  const scriptcolumns = [
    { id: "Action", label: "Action", minWidth: 70 },
    { id: "S.No", label: "S.No", minWidth: 40 },
    { id: "stock_name", label: "Stock Name", minWidth: 110 },
    { id: "lot_size", label: "LotSize", minWidth: 80 },
    { id: "volume", label: "Volume", minWidth: 110 },
    { id: "lower_circuit_limit", label: "LC Limit", minWidth: 110 },
    { id: "upper_circuit_limit", label: "UC Limit", minWidth: 110 },
  ];
  const [Record, setRecord] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(25);
  const [newRecords, setNewRecords] = useState([]);
  const [filters, setFilters] = useState();
  const [filteredRecord, setfilteredRecord] = useState([]);
  const RecordColor = 0;
  const [value, setValue] = useState(0);
  const [AllRecordTab, setAllRecordTab] = useState(true);
  const [SelectedRecordTab, setSelectedRecordTab] = useState(false);
  const [ScriptSelectedRecord, setScriptSelectedRecord] = useState([]);
  const [filteredScriptRecord, setfilteredScriptRecord] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [checkboxes, setCheckboxes] = useState({});
  const [excelRecord, setExcelRecord] = useState([]);
  const [successDialog,setSuccessDialog]=useState(false);
  const [errorDialog,setErrorDialog]=useState(false);
  const [errorMessage,setErrorMessage]=useState("");
  const [successMessage,setSuccessMessage]=useState("");
  const [removeDialog,setRemoveDialog]=useState(false);
  const [removeItem,setRemoveItem]=useState();
  const [removeBulkDialog,setRemoveBulkDialog]=useState(false);
  let count = 0;

  useEffect(() => {
    if (count === 0) {
      fetchrecord();
      count += 1;
    }
  }, []);


  // this function is used to fetch record of automate scripts
  const fetchrecord = async () => {
    console.log("inside fetch record ")
    try {
      await fetch(`${BASE_URL}/getAutomatescriptrecord`, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.success === true) {
            console.log(
              "automate scritp date for record stock selection",
              res.data
            );
            
            setSelectedItems([]);
            setCheckboxes({});
            setRecord(res.data);
            setfilteredRecord(res.data);
            setScriptSelectedRecord(res.SelectedRecord);
            setfilteredScriptRecord(res.SelectedRecord);
            
            // const setexcelRecord = [];

            // Loop through each record in SelectedRecord
            const setexcelRecord = res.SelectedRecord.map((record, index) => {
              return {
                "Serial_number": index + 1,
                "symbol": record.stock_name,
                "exchange": record.exchange,
                "Kite_symbol":record.kite_symbol,
                "symbol_exists":record.symbol_exists
              };
            });

            console.log("setExcelRecord",setexcelRecord)
            setExcelRecord(setexcelRecord);

            setLoading(false);

            // console.log("lot_size",res.lot_size)
          } else {
            console.log("data not found");
            setLoading(false);
            setErrorMessage(`Error: ${res.message}`);
            setErrorDialog(true)
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage("")
              }, 1700);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
          setErrorMessage(`Error: ${error.message}`);
          setErrorDialog(true)
          setTimeout(() => {
            setErrorDialog(false)
            setErrorMessage("")
            }, 1700);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false)
      setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
    }
  };

  //  this function is used to handle change page
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    let startindex = newPage * rowsPerPage;
    console.log("startindex", startindex);
    let endindex = Math.min(startindex + rowsPerPage, Record.length);
    console.log("endindex", endindex);
    setStartIndex(startindex);
    setEndIndex(endindex);
  };

  //  this function is used to handle rows change in per page
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setEndIndex(+event.target.value);
    setStartIndex(0);
    setPage(0);
  };

  //  this fucntion is used to open price of market
  const showopen = (row) => {
    // console.log(row.ohlc.open);
    if (!row.ohlc) {
      return 0;
    } else {
      let Open = row.ohlc.open;
      // console.log("open",Open)
      return Open;
    }
  };
  //  this fucntion is used to show close price of market
  const showclose = (row) => {
    if (!row.ohlc) {
      return 0;
    } else {
      let close = row.ohlc.close;
      return close;
    }
  };
  //  this function is used to show loe price of a stock
  const showlow = (row) => {
    if (!row.ohlc) {
      return 0;
    } else {
      let low = row.ohlc.low;
      return low;
    }
  };

  // this function is used to show high price

  const showhigh = (row) => {
    if (!row.ohlc) {
      return 0;
    } else {
      let high = row.ohlc.high;
      return high;
    }
  };

  // this function is used to render the left toolbar

  const scriptLeftToolbarTemplate = () => {
    return (
      <>
        <span className="p-input-icon-left table-search">
          <i className="pi pi-search" />
          <InputText
            type="search"
            value={filters}
            onChange={scripthandleSearch}
            placeholder="Search..."
          />
        </span>
      </>
    );
  };

  //  this function is used to show right toolbar 
  const scriptRightToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2 table-prehead-right">
        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            endIcon={<DeleteIcon />}
            onClick={confirmBulkRemove}
          >
            Remove All
          </Button>
          <Button
            variant="contained"
            endIcon={<DownloadIcon />}
            onClick={exportCSV}
          >
            Export
          </Button>
        </Stack>
      </div>
    );
  };

   // this fucntion is used to show left toolbar 
  const leftToolbarTemplate = () => {
    return (
      <>
        <span className="p-input-icon-left table-search">
          <i className="pi pi-search" />
          <InputText
            type="search"
            value={filters}
            onChange={handleSearch}
            placeholder="Search..."
          />
        </span>
      </>
    );
  };

  // this fucntion is used to show right toolbar 
  const rightToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2 table-prehead-right">
        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            
            onClick={handleBulkAction}
          >
            Save All
          </Button>

          <Button
            variant="contained"
            endIcon={<DownloadIcon />}
            onClick={exportCSV}
          >
            Export
          </Button>
        </Stack>
      </div>
    );
  };

  // this fucntion is used to show a center div 
  const centerToolbarTemplate = () => {
    return (
      <div className="centerToolbarTemplate">
        <Tabs value={value} onChange={handleChange}>
          <Tab
            style={{ padding: 0, fontSize: "13px" }}
            label={`All Records ${selectedItems.length}`}
            onClick={(e) => {
              handletabSelection(e, "AllRecord");
            }}
          />

          <Tab
            style={{ padding: 0, fontSize: "13px" }}
            label={`Selected Records ${ScriptSelectedRecord.length}`}
            onClick={(e) => {
              handletabSelection(e, "selectedrecord");
            }}
          />
        </Tabs>
      </div>
    );
  };

  //  this fucntion is used to manage handle change of values

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // this fucntion is used to select a tab 
  const handletabSelection = async (event, type) => {
    console.log("type form signle click", type);

    if (type === "AllRecord") {
      setSelectedRecordTab(false);
      setSelectedItems([]);
      setAllRecordTab(true);

    } else if (type === "selectedrecord") {
      setAllRecordTab(false);
      setSelectedItems([]);
      setSelectedRecordTab(true);
    }
  };

  //  this fucntion is used to search item in script records
  const scripthandleSearch = (event) => {
    let filetertext = event.target.value;
    setFilters(event.target.value);
    setPage(0);
    setfilteredScriptRecord(
      ScriptSelectedRecord.filter((row) =>
        Object.values(row).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(filetertext.toLowerCase())
        )
      )
    );
  };

  //  this fucntion is used to search item 
  const handleSearch = (event) => {
    let filetertext = event.target.value;
    setFilters(event.target.value);
    setPage(0);
    setfilteredRecord(
      Record.filter((row) =>
        Object.values(row).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(filetertext.toLowerCase())
        )
      )
    );
  };

 
  //   this function is used to export excel
  const exportCSV = () => {
    import("xlsx").then((xlsx) => {
      try {
        // Convert the array of objects to a worksheet
        const worksheet = xlsx.utils.json_to_sheet(excelRecord);
  
        // Convert the worksheet to a CSV file
        const csvContent = xlsx.utils.sheet_to_csv(worksheet);
  
        // Save the CSV file
        saveAsCSVFile(csvContent, "symbol_exchange");
      } catch (error) {
        console.error("Error exporting data to CSV:", error);
      }
    });
  };
  
  //  this fucntion is used to save a file as csv
  const saveAsCSVFile = (content, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        const CSV_EXTENSION = ".csv";
  
        const data = new Blob([content], {
          type: "text/csv;charset=utf-8",
        });
  
        module.default.saveAs(data, fileName + CSV_EXTENSION);
      }
    });
  };

  // this fucntion is used to add item in excel to download
  const AddItemInExcel = async (row) => {
    try{
    console.log("selected row", row);
    let selectionType = "SingleRecord";

    let data = JSON.stringify({
      SelectedRecord: row,
      SelectionType: selectionType,
    });

    if (ScriptSelectedRecord.length >= 25) {
      setErrorMessage("You Have Reach Maximum Limit of 25. Please Remove Some Item To Add New.")
      setErrorDialog(true)
      setTimeout(() => {
      setErrorDialog(false)
      setErrorMessage("")
      }, 1700);
    } else {
      await fetch(`${BASE_URL}/addAutomatescriptrecord`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.success === true) {
            console.log("Response", res.message);
            setSuccessMessage(res.message);
            setSuccessDialog(true);
            fetchrecord();
            setTimeout(() => {
              setSuccessDialog(false)
              setSuccessMessage("")
              }, 1700);
          } else {
            console.log("Response", res.message);

            setErrorMessage(res.message);
            setErrorDialog(true)
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage("")
              }, 1700);
          }
        })
        .catch((error) => {
          console.error("Error Inserting data:", error);
          setErrorMessage(`Error: ${error.message}`);
          setErrorDialog(true)
          setTimeout(() => {
            setErrorDialog(false)
            setErrorMessage("")
            }, 1700);
        });
    }
  }catch(error){
    setLoading(false)
    setErrorMessage(`Error: ${error.message}`);
    setErrorDialog(true)
    setTimeout(() => {
      setErrorDialog(false)
      setErrorMessage("")
      }, 1700);
  }
  };

  //  this funciton is used to remove item from excel
  const RemoveItemExcel = async () => {
    try{
    console.log("selected row", removeItem);
    setRemoveDialog(false);
    let selectionType = "SingleRecord";

    let data = JSON.stringify({
      SelectedRecord: removeItem,
      SelectionType: selectionType,
    });

    await fetch(`${BASE_URL}/deleteAutomatescriptrecord`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success === true) {
          console.log("Response", res.message);
          setSuccessMessage(res.message);
          setSuccessDialog(true);
          fetchrecord();
          
          setTimeout(() => {
            setSuccessDialog(false)
            setSuccessMessage("")
            }, 1700);
        } else {
          console.log("Response", res.message);
          setErrorMessage(res.message);
          setErrorDialog(true)
          setTimeout(() => {
            setErrorDialog(false)
            setErrorMessage("")
            }, 1700);
        }
      })
      .catch((error) => {
        console.error("Error Inserting data:", error);
        setErrorMessage(error);
        setErrorDialog(true)
        setTimeout(() => {
          setErrorDialog(false)
          setErrorMessage("")
          }, 1700);
      });
    }catch(error){
      setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
    }
  };

 

  // this function is used to handle toggle radio  button 
  const handleCheckboxChange = (event, row) => {
    const { name, checked } = event.target;
    setCheckboxes(prevState => ({
      ...prevState,
      [name]: checked,
    }));

    if (checked) {
      setSelectedItems([...selectedItems, row]);
    } else {
      setSelectedItems(selectedItems.filter((item) => item.name !== row.name));
    }

    console.log("selectedItems", selectedItems);
  };



  //  this function  is used to handle bulk addtion of stocks
  const handleBulkAction = async () => {
    try{
      
  
    // Perform action on selectedItems
    console.log("Selected Items for action: ", selectedItems);
    // Add your bulk action logic here
    let selectionType = "MultipleRecord";

    let data = JSON.stringify({
      SelectedRecord: selectedItems,
      SelectionType: selectionType,
    });

    if (ScriptSelectedRecord.length >= 25) {
      setErrorMessage("You Have Reach Maximum Limit of 25. Please Remove Some Item To Add New.")
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
    }
    else if (ScriptSelectedRecord.length + selectedItems.length > 26) {
      setErrorMessage("Adding these items will exceed the maximum limit of 25. Please remove some items before adding new ones.");
      setErrorDialog(true);
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
    } 
    else {
      await fetch(`${BASE_URL}/addAutomatescriptrecord`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.success === true) {
            console.log("Response", res.message);
            console.log("existingRecords", res.existingRecords);
            if(res.existingRecords.length === 0){
              setSelectedItems([]);
              fetchrecord();
              setCheckboxes({});
              setSuccessMessage(res.message);
              setSuccessDialog(true);
             
              setTimeout(() => {
                setSuccessDialog(false)
                setSuccessMessage("")
                }, 2000);
            }else{
              setSuccessDialog(true);
              fetchrecord();
              setSuccessMessage(` This ${res.existingRecords.name} Record Already Exist. Rest All Record Inserted.`);
              setCheckboxes({});
              setSelectedItems([]);
              setTimeout(() => {
                setSuccessDialog(false)
                setSuccessMessage("")
                }, 2000);
            }
            
            
          } else {
            setSelectedItems([]);
            setCheckboxes({});
            fetchrecord();
            console.log("Response", res.message);
            setErrorMessage(res.message);
            setErrorDialog(true)
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage("")
              }, 1700);
          }
        })
        .catch((error) => {
          console.error("Error Inserting data:", error);
          setSelectedItems([]);
          setCheckboxes({});
          fetchrecord();
          setErrorMessage(error);
            setErrorDialog(true)
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage("")
              }, 1700);
        });
      
    }
  }catch(error){
    setErrorMessage(`Error: ${error.message}`);
    setErrorDialog(true)
    setTimeout(() => {
      setErrorDialog(false)
      setErrorMessage("")
      }, 1700);
  }
  };

  //  this fucntion is used to remove multiple item at a time
  const handleBulkRemove = async () => {
    try{

    
    let selectionType = "MultipleRecord";
    setRemoveBulkDialog(false);

    let data = JSON.stringify({
      SelectedRecord: ScriptSelectedRecord,
      SelectionType: selectionType,
    });

    await fetch(`${BASE_URL}/deleteAutomatescriptrecord`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success === true) {
          console.log("Response", res.message);
          setSuccessMessage(res.message);
          setSuccessDialog(true);
          fetchrecord();
          setTimeout(() => {
            setSuccessDialog(false)
            setSuccessMessage("")
            }, 1700);
        } else {
          console.log("Response", res.message);
          setErrorMessage(res.message);
          setErrorDialog(true)
          setTimeout(() => {
            setErrorDialog(false)
            setErrorMessage("")
            }, 1700);
        }
      })
      .catch((error) => {
        console.error("Error Inserting data:", error);
        setErrorMessage(error);
        setErrorDialog(true)
        setTimeout(() => {
          setErrorDialog(false)
          setErrorMessage("")
          }, 1700);
      });
    }catch(error){
      setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
    }

  };

  
  const isRowSelected = (name) =>{
    selectedItems.some((item) => item.name === name);
  }

// to hide remove dialog box
  const hideRemoveDialog = () => {
    setRemoveDialog(false);
  };
  //  hide bulk remove dialog
  const hideRemoveBulkDialog = () => {
    setRemoveBulkDialog(false);
  };


//  open remove dialog
  const confirmRemove=(row)=>{
    setRemoveItem(row)
    setRemoveDialog(true)
  }
  //  open bulk remove dialog
  const confirmBulkRemove=()=>{
    setRemoveBulkDialog(true)
  }
  

  return (
    <>
      <Sidebar />
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
          }}
        >
          <Loading />
        </div>
      ) : (
        <div className="add-user user-list">
          {AllRecordTab ? (
            <div className="container-fluid">
              <h2 style={{ marginTop: "0px" }}>Automate Script Record List</h2>
              <Toolbar
                className="table-pre-head"
                start={leftToolbarTemplate}
                end={rightToolbarTemplate}
                center={centerToolbarTemplate}
              ></Toolbar>
              <div className="table">
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer sx={{ maxHeight: 350 }}>
                    <Table
                      style={{ margin: 0 }}
                      stickyHeader
                      aria-label="sticky table"
                    >
                      <TableHead>
                        <TableRow>
                          {columns.map((column, index) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              title={
                                column.id === "last_quantity"
                                  ? "Last Quantity"
                                  : column.id === "buy_quantity"
                                  ? "Buy Quantity"
                                  : column.id === "sell_quantity"
                                  ? "Sell Quantity"
                                  : column.id === "lower_circuit_limit"
                                  ? "Lower Circuit Limit"
                                  : column.id === "upper_circuit_limit"
                                  ? "Upper Circuit Limit"
                                  : ""
                              }
                              style={{
                                textAlign: "center",
                                minWidth: column.minWidth,
                                backgroundColor: "#23499E",
                                color: "white",
                                zIndex:
                                  column.id === "S.No" ||
                                  column.id === "Stock_name" ||
                                  column.id === "Action"
                                    ? 20
                                    : 5,
                                left:
                                  column.id === "S.No"
                                    ? 98
                                    : column.id === "Stock_name"
                                    ? 150
                                    : column.id === "Action"
                                    ? 0
                                    : undefined,
                              }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      {filteredRecord.length > 0 ? (
                        <TableBody>
                          {filteredRecord
                            .slice(startIndex, endIndex)
                            .map((row, index) => {
                              const isNewRecord = newRecords.some(
                                (newRecord) => newRecord.id === row.id
                              );
                              const isSelected = isRowSelected(row.name);
                              // console.log("isNewRecord",isNewRecord)
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={row.code}
                                >
                                  {columns.map((column) => {
                                    const value = row[column.id];
                                    return (
                                      <TableCell
                                        style={{
                                          position: "sticky",
                                          backgroundColor:
                                            RecordColor == 1
                                              ? "#fff"
                                              : isNewRecord
                                              ? "lightgreen"
                                              : "#fff",
                                          zIndex:
                                            column.id === "S.No" ||
                                            column.id === "Stock_name" ||
                                            column.id === "Action"
                                              ? 10
                                              : 1,
                                          left:
                                            column.id === "S.No"
                                              ? 98
                                              : column.id === "Stock_name"
                                              ? 150
                                              : column.id === "Action"
                                              ? 0
                                              : undefined,
                                        }}
                                        class="table-cell-screenerTab"
                                        key={column.id}
                                        align={column.align}
                                      >
                                        {column.id === "S.No" ? (
                                          index + 1
                                        ) : column.id === "open" ? (
                                          showopen(row)
                                        ) : column.id === "close" ? (
                                          showclose(row)
                                        ) : column.id === "high" ? (
                                          showhigh(row)
                                        ) : column.id === "low" ? (
                                          showlow(row)
                                        ) : column.id === "Action" ? (
                                          <div className="actions">
                                            <Checkbox
                                              checked={isSelected}
                                              onChange={(event) =>
                                                handleCheckboxChange(event, row)
                                              }
                                            />
                                            <span>
                                            <i
                                              className="pi pi-plus-circle"
                                              style={{
                                                color: "#23499E",
                                                cursor: "pointer",
                                                marginRight: "10px",
                                              }}
                                              title="Add In Script Record"
                                              onClick={() =>
                                                AddItemInExcel(row)
                                              }
                                            ></i>
                                            </span>
                                          </div>
                                        ) : (
                                          value
                                        )}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      ) : null}
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[25, 50, 75, 100]}
                    component="div"
                    count={filteredRecord.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper>
              </div>
            </div>
          ) : SelectedRecordTab ? (
            <div className="container-fluid">
              <h2 style={{ marginTop: "0px" }}>Automate Script Record List</h2>
              <Toolbar
                className="table-pre-head"
                start={scriptLeftToolbarTemplate}
                end={scriptRightToolbarTemplate}
                center={centerToolbarTemplate}
              ></Toolbar>
              <div className="table">
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer sx={{ maxHeight: 350 }}>
                    <Table
                      style={{ margin: 0 }}
                      stickyHeader
                      aria-label="sticky table"
                    >
                      <TableHead>
                        <TableRow>
                          {scriptcolumns.map((column, index) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{
                                textAlign: "center",
                                minWidth: column.minWidth,
                                backgroundColor: "#23499E",
                                color: "white",
                                zIndex:
                                  column.id === "S.No" ||
                                  column.id === "Stock_name" ||
                                  column.id === "Action"
                                    ? 20
                                    : 5,
                                left:
                                  column.id === "S.No"
                                    ? 70
                                    : column.id === "Stock_name"
                                    ? 121
                                    : column.id === "Action"
                                    ? 0
                                    : undefined,
                              }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      {filteredScriptRecord.length > 0 ? (
                        <TableBody>
                          {filteredScriptRecord
                            .slice(startIndex, endIndex)
                            .map((row, index) => {
                              const isNewRecord = newRecords.some(
                                (newRecord) => newRecord.id === row.id
                              );
                              // console.log("isNewRecord",isNewRecord)
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={row.code}
                                >
                                  {scriptcolumns.map((column) => {
                                    const value = row[column.id];
                                    return (
                                      <TableCell
                                        style={{
                                          position: "sticky",
                                          backgroundColor:
                                            RecordColor == 1
                                              ? "#fff"
                                              : isNewRecord
                                              ? "lightgreen"
                                              : "#fff",
                                          zIndex:
                                            column.id === "S.No" ||
                                            column.id === "Stock_name" ||
                                            column.id === "Action"
                                              ? 10
                                              : 1,
                                          left:
                                            column.id === "S.No"
                                              ? 70
                                              : column.id === "Stock_name"
                                              ? 121
                                              : column.id === "Action"
                                              ? 0
                                              : undefined,
                                        }}
                                        class="table-cell-screenerTab"
                                        key={column.id}
                                        align={column.align}
                                      >
                                        {column.id === "S.No" ? (
                                          index + 1
                                        ) : column.id === "Action" ? (
                                          <div className="actions">
                                            <i
                                              className="pi pi-times-circle"
                                              style={{
                                                color: "#23499E",
                                                cursor: "pointer",
                                                marginRight: "10px",
                                              }}
                                              title="Delete Row"
                                              onClick={() =>
                                                confirmRemove(row)
                                              }
                                            ></i>
                                          </div>
                                        ) : (
                                          value
                                        )}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      ) : null}
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[25, 50, 75, 100]}
                    component="div"
                    count={filteredScriptRecord.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper>
              </div>
            </div>
          ) : null}


          {/*Error Message Dialog */}
          <Dialog
      open={errorDialog}
      onClose={()=>{setErrorDialog(false)}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle  id="alert-dialog-title">
      <h4 style={{ color: "red" }}>Failure</h4>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
         
               
          {errorMessage}
           
        
        </DialogContentText>
      </DialogContent>
     
          </Dialog>

           {/*Success Message Dialog */}
           <Dialog
      open={successDialog}
      onClose={()=>{setSuccessDialog(false)}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle  id="alert-dialog-title">
      <h4 style={{ color: "green"}}>Success</h4>
       
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
         
             
               <span style={{ color: "black" }}>
                  {successMessage}
                </span>
              
 
        </DialogContentText>
      </DialogContent>
     
           </Dialog>


         {/*Remove all  dialog */}
          <Dialog
            open={removeDialog}
            onClose={hideRemoveDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
              {"Confirm Remove"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                
                  <span style={{ color: "black" }}>
                    Are you sure, you want to Remove This Stock. 
                  </span>
             
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className="btn-cancel"
                variant="outlined"
                color="error"
                onClick={hideRemoveDialog}
              >
                No
              </Button>
              <Button className="btn-submit"
                variant="outlined"
                color="success"
                onClick={RemoveItemExcel}
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>

         {/* Bulk Remove all  dialog */}
          <Dialog
            open={removeBulkDialog}
            onClose={hideRemoveBulkDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
              {"Confirm Bulk Remove"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                
                  <span style={{ color: "black" }}>
                    Are you sure, you want to delete All Stock form List. 
                  </span>
             
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className="btn-cancel"
                variant="outlined"
                color="error"
                onClick={hideRemoveBulkDialog}
              >
                No
              </Button>
              <Button className="btn-submit"
                variant="outlined"
                color="success"
                onClick={handleBulkRemove}
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </>
  );
};

export default AutomateScriptRecord;
